'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:ProjectShowCtrl
 * @description
 * # ProjectShowCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
  .controller('ProjectShowCtrl', ['$rootScope', '$scope', '$state', '$stateParams', '$mdDialog', 'Project',
  'GoogleApi', 'toaster', 'cfpLoadingBar', 'Employee', '$q', 'Pagination', '$timeout', '$window', 'ProjectActions',
   function($rootScope, $scope, $state, $stateParams, $mdDialog, Project, GoogleApi, toaster, cfpLoadingBar,
     Employee, $q, Pagination, $timeout, $window, ProjectActions) {
    $scope.project = {};
    $scope.rapeList = [];
    $scope.pmList = [];
    $scope.projectDaysStages = [];
    $scope.projectId = $stateParams.projectId;
    $scope.foldersInDrive = [];

    $scope.moveAllFiles = function(sourceFolderId, targetFolderId) {
      return GoogleApi.retrieveFilesInFolder(sourceFolderId).then(response => {
        const files = response.result.files || [];

        const promises = files.map(file => {
          return GoogleApi.moveFile(file.id, sourceFolderId, targetFolderId);
        });

        return Promise.all(promises);
      });
    }

    $scope.migrarArchivos = function() {
      const driveID = $scope.project.drive_root_id;
      const projectCode = $scope.project.project_code;

      cfpLoadingBar.start();

      const folderMap = {
        [`2. ${projectCode}_Orden de Compra`]: `4. ${projectCode}_Autorización del Cliente y OC`,
        [`3. ${projectCode}_Análisis`]: `6. ${projectCode}_Análisis`,
        [`4. ${projectCode}_Descripción del Proyecto-Cotización`]: `1. ${projectCode}_Requerimientos`,
        [`6. ${projectCode}_Registros de Desarrollo`]: `7. ${projectCode}_Desarrollo y Pruebas`,
      };

      return GoogleApi.retrieveFilesInFolder(driveID).then(function(response) {
        const remoteFiles = response.result.files;

        const copyPromises = Object.entries(folderMap).map(([oldName, newName]) => {
          const sourceFolder = remoteFiles.find(e => e.name.trim().endsWith(oldName));

          if (oldName.includes('_Descripción del Proyecto-Cotización')) {
            const originalFolder = remoteFiles.find(e => e.name.includes('_Descripción del Proyecto-Cotización'));
            const targetFolder = remoteFiles.find(e => e.name.includes('_Requerimientos'));
            if (originalFolder && targetFolder) {
              $scope.moveAllFiles(originalFolder.id, targetFolder.id);
            }
          }

          if (sourceFolder) {
            return GoogleApi.updateFolderName(sourceFolder.id, newName);
          } else {
            return Promise.resolve();
          }
        });

        return Promise.all(copyPromises).then(() => {
          cfpLoadingBar.complete();
          toaster.pop('success', 'Migración Exitosa', 'Los archivos fueron migrados correctamente.');
        }).catch(error => {
          cfpLoadingBar.complete();
          toaster.pop('error', 'Error en la Migración', 'Ocurrió un problema al copiar los archivos.');
        });

      }).catch(error => {
        cfpLoadingBar.complete();
        toaster.pop('error', 'Error al Obtener Carpetas', 'No se pudo acceder al contenido de Drive.');
      });
    };

    $scope.foldersNames = GoogleApi.folderStructureFor([]);

    $scope.driveFoldersCheck = [];

    $rootScope.projectHash = {
      'project': {
        'id': 0,
        'project_date': new Date(moment()),
        'audit_comment': '',
        'rape_id': '',
        'eta': ''
      },
      'state': '',
      'estimatedHoursCount': 0,
    };
    $(window).scrollTop(0);
    Project.find($stateParams.projectId).then(function(response) {
      $scope.project = response.data.project;
      $rootScope.projectHash.project.id = $scope.project.id;
      $rootScope.projectHash.project.rape_id = $scope.project.rape_id;
      $rootScope.projectHash.project.eta = new Date(moment($scope.project.eta));
      $scope.currentFolderUrl = `https://drive.google.com/drive/folders/${$scope.project.drive_root_id}`
    }, function(error) {
      Project.error(error);
    });

    Employee.index({params: {by_rape: true, by_status: true, per_page: 'all'}}).then(function(response) {
      $scope.rapeList = response.data.employees;
    },function(error) {
      Employee.error(error);
    });

    $scope.saveComment = function(state) {
      $rootScope.projectHash.state = state.event;
      $rootScope.projectHash.title = state.name;
      var currentScrollPosition = window.scrollY;
      $mdDialog.show({
        controller: $rootScope.CommentCtrl,
        templateUrl: 'views/comment_dialog.html',
        scope: $scope,
        preserveScope: true,
        onRemoving: function() {
          window.scrollTo(0, currentScrollPosition);
        }
      }).then(function(result) {
        $rootScope.projectHash.project.project_date = result.date;
        $rootScope.projectHash.project.audit_comment = result.comment;
        $rootScope.projectHash.project.rape_id = result.rape_id;

        $rootScope.projectHash.project.eta = result.eta;
        Project.aasm_transition($rootScope.projectHash).then(function() {
          $state.reload();
        }, function(error) {
          Project.error(error);
        });
      });
    };

    $scope.openExtender = function(state) {
      $rootScope.projectHash.state = state.event;
      $rootScope.projectHash.title = state.name;
      var currentScrollPosition = window.scrollY;
      $mdDialog.show({
        controller: $rootScope.CommentCtrl,
        templateUrl: 'views/projects/_extend_eta.html',
        scope: $scope,
        preserveScope: true,
        onRemoving: function() {
          window.scrollTo(0, currentScrollPosition);
        }
      }).then(function(result) {
        var params = {
          'project': angular.copy($scope.project)
        };
        params.project.audit_comment = result.comment;
        params.project.eta = result.eta;
        Project.save(params).then(function() {
          $state.reload();
          toaster.pop('success', 'ETA actualizado', 'Se actualizo el ETA del proyecto');
        }, function(error) {
          Project.error(error);
          toaster.pop('warning', 'Cancelado', 'Error en la Actualización');
        });
      });
    };
    $scope.addComment = function(state) {
      $rootScope.projectHash.state = state.event;
      $rootScope.projectHash.title = state.name;
      var currentScrollPosition = window.scrollY;
      $mdDialog.show({
        controller: $scope.HistoryCommentCtrl,
        templateUrl: 'views/projects/_addcomment.html',
        scope: $scope,
        preserveScope: true,
        onRemoving: function() {
          window.scrollTo(0, currentScrollPosition);
        }
      }).then(function(result) {
        var params = {
          'project': {
            id: $scope.project.id,
            audit_comment: result.comment
          }
        };

        Project.comment(params).then(function() {
          $state.reload();
          toaster.pop('success', 'Comentario', 'Comentario Añadido');
        }, function(error) {
          Project.error(error);
          toaster.pop('warning', 'Comentario', 'Error al añadir el Comentario');
        });
      });
    };

    $scope.HistoryCommentCtrl = ['$scope', function($scope) {
      $scope.commentHash = {
        'comment': '',
        'date': new Date(),
        'rape_id': $scope.projectHash.project.rape_id,
        'name': '',
        'project_type_catalog_id': '',
        'id': $scope.projectHash.project.id,
        'eta': $scope.projectHash.project.eta
      };

      if('project' in $scope.projectHash) {
        $scope.commentHash.id = $scope.projectHash.project.id;
      }

      $scope.save = function() {
        if (!$scope.commentHash.comment || $scope.commentHash.comment.trim() === "") {
          toaster.pop('warning', 'Comentario', 'Por favor, agregue un comentario');
          return;
        }
        $mdDialog.hide($scope.commentHash);
      };
      $scope.cancel = function() {
        $mdDialog.cancel();
      };
    }];

    $scope.completelyInvoiced = function() {
      $rootScope.projectHash.title = $scope.project.invoice_action;
      var currentScrollPosition = window.scrollY;
      $mdDialog.show({
        controller: $rootScope.CommentCtrl,
        templateUrl: 'views/comment_dialog.html',
        scope: $scope,
        preserveScope: true,
        onRemoving: function() {
          window.scrollTo(0, currentScrollPosition);
        }
      }).then(function(result) {
        var params = {
          id: $scope.project.id,
          audit_comment: result.comment,
          project_date: result.date
        };
        if($scope.project.invoice_action === '100% facturas ya realizadas')
        {
          Project.completelyInvoiced(params).then(function() {
            $state.reload();
          }, function(error) {
            Project.error(error);
          });
        }
        else
        {
          Project.partiallyInvoiced(params).then(function() {
            $state.reload();
          }, function(error) {
            Project.error(error);
          });
        }
      }, function(error) {
        toaster.pop('warning', 'Cancelado', 'No se realizaron cambios en el estado de facturación');
      });
    };

    // This function recreates missin or misslabeled folders in the project root drive folder.
    $scope.recreateDriveFolderStructure = function() {
      $scope.migrarArchivos().then(() => {
        GoogleApi.recreateFolderStructure($scope.project.drive_root_id, $scope.project.project_code).then(function(response) {
          $scope.foldersNames = response.folders;
          $scope.driveFoldersCheck = response.checklist;
          var currentScrollPosition = window.scrollY;
          $mdDialog.show({
            controller: $scope.folderCheckDialogCtrl,
            templateUrl: 'views/folder_check_dialog.html',
            scope: $scope,
            preserveScope: true,
            onRemoving: function() {
              window.scrollTo(0, currentScrollPosition);
            }
          }).then(function(result) {
            // Recreate missing folders.
            GoogleApi.createMissingFolder($scope.project.drive_root_id, $scope.project.project_code, response.checklist, response.folders).then(function() {
              toaster.pop('warning', 'Estructura de carpetas', 'Las carpetas se estan creando, favor de esperar un momento');
            }, function(error) {
              Project.console.error((error));
            });
          }, function() {
            // Dialog was closed.
          });
        }, function(error) {
          Project.error(error);
        });
      })
    }

    Project.project_stages({
      id: $stateParams.projectId,
    }).then(function(response) {
      $scope.projectDaysStages = response.data.steps
    }, function(error) {
      Project.error(error);
    });

    $rootScope.folderCheckDialogCtrl = ['$scope', function($scope) {
      $scope.save = function() {
        $mdDialog.hide('Start recreation of folder structure.');
      };
      $scope.cancel = function() {
        $mdDialog.cancel();
      };
    }];

    $scope.extendProject = function(project) {
      ProjectActions.extendProject($scope, project);
    };

    $scope.isEventButtonVisible = function(event) {
      const adminEvents = ['reactivate'];
      
      if (adminEvents.includes(event.event)) {
        return $scope.userIsAdmin;
      }
      return true;
    };
  }]);
